import React from 'react'
import Modal from '../../../components/Modal'

export default function DisputeModal({
  disputeId,
  setDisputeId,
  disputeComment,
  setDisputeComment,
  disputing,
  submitDispute,
  disputeFile,
  setDisputeFile,
  disputePreview,
  setDisputePreview,
  disputeVideoLink,
  setDisputeVideoLink
}) {
  return (
    <Modal
      isOpen={!!disputeId}
      onClose={() => { 
        setDisputeId(null)
        setDisputeComment('')
        setDisputeFile(null)
        setDisputePreview(null)
        setDisputeVideoLink('') 
      }}
      title="Оспорить штраф"
      isBottomSheet={true}
    >
      <div className="payments-form-wrapper">
        <form className="payments-form" onSubmit={submitDispute}>
          <div className="input-group">
            <label htmlFor="dispute-comment">Причина оспаривания</label>
            <textarea
              id="dispute-comment"
              className="input"
              rows="3"
              placeholder="Объясните, почему штраф выписан неверно..."
              value={disputeComment}
              onChange={(e) => setDisputeComment(e.target.value)}
              required
            />
          </div>
          
          <div className="input-group">
            <label>Прикрепить доказательство (фото или видео)</label>
            {!disputePreview ? (
              <label 
                style={{ 
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  padding: '16px', border: '2px dashed var(--border-color, #ddd)', borderRadius: '12px',
                  cursor: 'pointer', color: 'var(--text-secondary)', fontSize: '13px',
                  background: 'var(--surface-hover, #f8f8f8)', transition: 'all 0.2s'
                }}
              >
                <span style={{ fontSize: '20px' }}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg> / </span>
                Выберите фото или видео файл
                <input
                  type="file"
                  multiple
                  accept="image/*,video/*"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files?.[0]
                    if (!file) return
                    const isVideo = file.type.startsWith('video/')
                    const limit = isVideo ? 30 * 1024 * 1024 : 50 * 1024 * 1024
                    if (file.size > limit) {
                      alert(`Максимальный размер: для фото — 50 МБ, для видео — 30 МБ`)
                      return
                    }
                    setDisputeFile(file)
                    setDisputePreview(URL.createObjectURL(file))
                  }}
                />
              </label>
            ) : (
              <div style={{ position: 'relative', borderRadius: '12px', overflow: 'hidden', border: '1px solid var(--border-color, #ddd)' }}>
                {disputeFile?.type?.startsWith('video/') ? (
                  <video 
                    src={disputePreview} 
                    controls 
                    style={{ width: '100%', maxHeight: '200px', display: 'block', background: '#000' }} 
                  />
                ) : (
                  <img 
                    src={disputePreview} 
                    alt="Доказательство" 
                    style={{ width: '100%', maxHeight: '200px', objectFit: 'cover', display: 'block' }} 
                  />
                )}
                <button
                  type="button"
                  onClick={() => { setDisputeFile(null); setDisputePreview(null) }}
                  style={{ 
                    position: 'absolute', top: '8px', right: '8px',
                    background: 'rgba(0,0,0,0.6)', color: '#fff', border: 'none', borderRadius: '50%',
                    width: '28px', height: '28px', cursor: 'pointer', fontSize: '14px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
                <div style={{ 
                  padding: '6px 12px', fontSize: '11px', color: 'var(--text-secondary)',
                  background: 'var(--surface-hover, #f8f8f8)'
                }}>
                  {disputeFile?.name}
                </div>
              </div>
            )}
          </div>

          <div className="input-group" style={{ marginTop: '12px' }}>
            <label htmlFor="dispute-video-link"> Или укажите ссылку на видео / камеру</label>
            <input
              type="url"
              id="dispute-video-link"
              className="input"
              placeholder="https://drive.google.com/... или ссылка на систему видеонаблюдения"
              value={disputeVideoLink}
              onChange={(e) => setDisputeVideoLink(e.target.value)}
            />
            <span style={{ fontSize: '11px', color: 'var(--text-secondary)', marginTop: '4px', display: 'block' }}>
              Полезно, если запись с камеры хранится на Google/Yandex Диске или в системе видеонаблюдения (например, Ivideon, Ростелеком).
            </span>
          </div>
          
          <div className="payments-form-actions" style={{ marginTop: '20px' }}>
            <button type="submit" className="btn btn-primary" disabled={disputing}>
              {disputing ? 'Отправка...' : 'Отправить на рассмотрение'}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  )
}
